import { render, staticRenderFns } from "./PatientEstimate.vue?vue&type=template&id=176e632b&scoped=true&"
import script from "./PatientEstimate.vue?vue&type=script&lang=ts&"
export * from "./PatientEstimate.vue?vue&type=script&lang=ts&"
import style0 from "./PatientEstimate.vue?vue&type=style&index=0&id=176e632b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176e632b",
  null
  
)

export default component.exports